function getFellestekst(cb) {
  var query = "uri = /vrtx/fellestekst/hvordan-soke-tilpasset/land/alle.html";
  var fields = "*";
  var sort = "publish-date desc";

  getPropertySearchResults(query, fields, sort, function(data) {
    if(data.results && data.results.length > 0) {
      var sharedTexts = {};

      data.results.forEach(function(file) {
        var name = file.name.replace(/\.html$/i, "");
        sharedTexts[name] = {};

        if(file.properties["resource:shared-text-box"]) {
          file.properties["resource:shared-text-box"].forEach(function(sharedText) {
            sharedTexts[name][sharedText.id] = sharedText;
          });
        }
      });
      cb(sharedTexts);
    }
  });
}

function getPropertySearchResults(query, fields, sort, cb) {
  var propertySearchService = "/vrtx/__vrtx/app-services/property-query";
  return $.ajax({
    type: "GET",
    url: propertySearchService +
         "?q=" + encodeURIComponent(query) +
         "&fields=" + encodeURIComponent(fields) +
         "&sort=" + encodeURIComponent(sort) +
         "&format=json-compact",
    cache: false,
    contentType: "application/json;charset=utf-8",
    success: function(data) {
      cb(data);
    },
    error: (xhr, textStatus, errorThrown) => {
      alert(xhr.status + " - " + textStatus);
    }
  });
}

function sortObj(obj, sortBy) {
  var arr = [];
  for(var elm in obj) {
    arr.push({
      "id": elm,
      "data": obj[elm]
    })
  }
  arr.sort(function(a, b){
    if(a.data[sortBy] < b.data[sortBy]) return -1;
    if(a.data[sortBy] > b.data[sortBy]) return 1;
    return 0;
  })
  var newObj = {};
  for(var elm in arr) {
    newObj[arr[elm].id] = arr[elm].data
  }
  return newObj;
}

function formatData(data, field) {
  var obj = sortObj(data, field);
  var code = "";
  var country = "";

  var i = 0;
  var len = 0;
  for(var elm in data) {
   len++;
  }
  for(var elm in obj) {
    var item = obj[elm];
    var c = $(item[field]).text();
    country += c;
    code += "'" + c + "': '" + item.id + "'";

    if(i < (len-1)) {
      country += " | ";
      code += ",";
    }

    i++;
  }

  return {
    "code": code,
    "country": country
  }
}

$(document).ready(function() {
  getFellestekst(function(data) {
    var sc = '$(".answer-option-external-id label").each(function() { var lbl = $(this); if(code[lbl.text()]) lbl.next().val(code[lbl.text()]); })';

    var en = formatData(data["alle"], "description-en");
    $("#en-ns").text(en.country);
    $("#en-ns-sc").text("var code = {" + en.code + "}; " + sc);

    var no = formatData(data["alle"], "description-no");
    $("#no-ns").text(no.country);
    $("#no-ns-sc").text("var code = {" + no.code + "}; " + sc);
  });
});
